export default "__VITE_ASSET__CObLiXVD__"